import React, { useEffect  , useState } from 'react'
import { Box, Grid, Paper, Typography, CircularProgress, TextField , Button , MenuItem , Autocomplete } from '@mui/material';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ButtonTheme from '../../components/ThemeButton/ThemeButton';
import { DatePicker } from '@mui/x-date-pickers';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import ApiService from "../../functions/apiService";
import moment from 'moment';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import MyTable from '../../components/Schedule/MyTable';
import Pagination from '@mui/material/Pagination';

const SwapReport = () => {
    let navigate = useNavigate();
    const ReqComponent = () => <span className='text-danger '>*</span>
    const [rows, setRows] = useState([]);
    const [loading , setLoading] = useState(false)
    const [fromDateSwap, setFromDateSwap] = useState(moment().startOf('month').toDate());
    const [toDateSwap, setToDateSwap] = useState(moment().endOf('month').toDate());
    const dateFrom =  moment(fromDateSwap).format('YYYY-MM-DD');
    const toDate = moment(toDateSwap).format('YYYY-MM-DD');
    const [employess , setEmployees] = useState([])
    const [selectedEmpCode, setSelectedEmpCode] = useState(null);
    const [page, setPage] = useState(1);
    const rowsPerPage = 100;


    const columns = [
        { field: 'Shift_Date', headerName: 'Shift Date', flex: 1 , valueGetter: (params) => {
            return moment(params?.row?.Shift_Date).format('MM/DD/YYYY');} 
        },
        { field: 'Shift_Code', headerName: 'Shift Code', flex: 1 },
        { field: 'Absent_Code', headerName: 'Absent Code', flex: 1 },
        { field: 'Request_By', headerName: 'Requested By', flex: 1 },
        { field: 'Request_To', headerName: 'Requested To', flex: 1 },
        { field: 'Response', headerName: 'Response', flex: 1 },
        { field: 'Status', headerName: 'Status', flex: 1 },
    ];

    const backFunction = () => {
        navigate('/firehouse/reports')
    }

    const getEmployeeSwapReport = () => {
        setLoading(true);
        ApiService.get(`/ot-swap-report-admin?start_date=${dateFrom}&end_date=${toDate}`)
        .then(({ data }) => {
            setLoading(false);
            const responseData = data.data || {};
            const formattedRows = Object.entries(responseData).map(([key, value], index) => ({
                id: index, 
                ...value,
            }));
            setRows(formattedRows);
        })
        .catch((err) => {
            toast.error(err?.response?.data?.message || 'Failed to fetch data');
            setLoading(false);
        });
    };

    useEffect(()=>{
        getEmployeeSwapReport()
    } , [dateFrom , toDate])

    useEffect(() =>{
        ApiService.get('/employeeToSwap').then(({ data }) => {
            setEmployees(data)
        }).catch(() => {
            console.error('error')
        })
    } , [])

    const handleChangePage = (event, value) => {
        setPage(value);
    };

    const filteredRows = selectedEmpCode
        ? rows.filter(row =>
            row.Emp_Code === selectedEmpCode.Emp_Code ||
            row.Orig_Emp_Code === selectedEmpCode.Emp_Code
        )
    : rows;

    const paginatedRows = filteredRows.slice(
        (page - 1) * rowsPerPage,
        page * rowsPerPage
    );

    const downloadCsv = () => {
        if (!filteredRows || filteredRows.length === 0) {
            toast.warning('No data to download.');
            return;
        }

        const headers = Object.keys(filteredRows[0]);

        const csv = [
            headers.join(','),
            ...filteredRows.map(row =>
                headers.map(field => {
                    let value = row[field];
                    if (field === 'Shift_Date' && value) {
                        value = moment(value).format('MM/DD/YYYY') + '.';
                    }
                    return JSON.stringify(value ?? '');
                }).join(',')
            )
        ].join('\n');

        const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
        const url = URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'swap-report.csv');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };



    return (
        <Paper className='p-4' sx={{ marginTop: '1rem' }}>
            <Box>
                <Button className=' text-decoration-none px-0' onClick={backFunction} style={{ color: '#555555' }}> <ArrowBackIosIcon /> Back</Button>
            </Box>
            <Typography variant="h6" className='mt-1'>Swap Report</Typography> 

            <div className="mt-1">
                <Grid container spacing={2}>
                    <Grid item xs={3}>
                        <label style={{ fontSize: "14px" }}>
                            For <ReqComponent />
                        </label>
                        <Box className="mt-1">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    value={fromDateSwap}
                                    onChange={(e) => setFromDateSwap(e)}
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {
                                            height: "48px",
                                            fontSize: "14px",
                                        },
                                    }}
                                    dateInputIcon={<CalendarTodayIcon />}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <label style={{ fontSize: "14px" }}>
                            To <ReqComponent />
                        </label>
                        <Box className="mt-1">
                            <LocalizationProvider dateAdapter={AdapterDateFns}>
                                <DatePicker
                                    value={toDateSwap}
                                    onChange={(e) => setToDateSwap(e)}
                                    sx={{
                                        width: "100%",
                                        "& .MuiInputBase-root": {
                                            height: "48px",
                                            fontSize: "14px",
                                        },
                                    }}
                                    dateInputIcon={<CalendarTodayIcon />}
                                />
                            </LocalizationProvider>
                        </Box>
                    </Grid>
                    <Grid item xs={3}>
                        <label style={{ fontSize: "14px" }}>
                            Employees
                        </label>
                        <Autocomplete
                            className="mt-1 w-100"
                            options={employess || []}
                            getOptionLabel={(option) => option.EA_Rank + ' ' + option.fullName}
                            value={selectedEmpCode}
                            onChange={(event, newValue) => setSelectedEmpCode(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    variant="outlined"
                                    size="small"
                                    InputProps={{
                                        ...params.InputProps,
                                        sx: {
                                            height: '48px',
                                            fontSize: '14px',
                                        },
                                    }}
                                    InputLabelProps={{
                                        sx: {
                                            marginTop: '3px',
                                            fontSize: '14px',
                                        },
                                    }}
                                />
                            )}
                            isOptionEqualToValue={(option, value) => option.Emp_Code === value.Emp_Code}
                        />

                    </Grid>
                    {filteredRows.length > 0 &&
                        <Grid item xs={3} sx={{marginTop:'30px' , display:'flex' , justifyContent:'end'}}>
                            <ButtonTheme type="submit" 
                                    variant="filled" color="primary"  onClick={downloadCsv}
                                >
                                    Download Swap Report
                            </ButtonTheme>
                        </Grid>
                    }
                    
                </Grid>
            </div>

            {loading && 
                <Box className="w-100 h-100 d-flex justify-content-center align-items-center font-fam mt-5">
                    <CircularProgress />
                </Box>
            }


            {filteredRows.length === 0 && !loading &&
                <div style={{ height: 500 , display:'block' , marginLeft:'36%' , marginRight:'auto' , paddingTop:'60px' }}>
                    <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                    <div className='mt-4'>
                        <span style={{ color: '#555555' , marginLeft:'110px' }}>
                            No Data
                        </span>
                    </div>
                </div>
            }

            {filteredRows.length > 0 && !loading && (
                <div className="mt-3">
                    <MyTable
                        rows={paginatedRows}
                        columns={columns}
                        checkboxSelection={false}
                        hideFooter={true}
                    />
                    <div className="mt-4" style={{display:'flex' , justifyContent:'end'}}>
                        <Pagination
                            count={Math.ceil(filteredRows.length / rowsPerPage)}
                            page={page}
                            onChange={handleChangePage}
                            color="primary"
                        />
                    </div>
                </div>
            )}

        </Paper>
  )
}

export default SwapReport